export var AnalyticsCategories;
(function (AnalyticsCategories) {
    AnalyticsCategories.dialog = 'dialog';
    AnalyticsCategories.iframe = 'iframe';
    AnalyticsCategories.inlineDialog = 'inlineDialog';
})(AnalyticsCategories || (AnalyticsCategories = {}));
export var AnalyticsActions;
(function (AnalyticsActions) {
    AnalyticsActions.create = 'create';
    AnalyticsActions.close = 'close';
    AnalyticsActions.error = 'error';
    AnalyticsActions.timeout = 'timeout';
    AnalyticsActions.established = 'established';
})(AnalyticsActions || (AnalyticsActions = {}));
export var allowedStrings = [
    AnalyticsActions.create,
    AnalyticsActions.close,
    AnalyticsActions.error,
    AnalyticsActions.timeout,
    AnalyticsActions.established
];
//# sourceMappingURL=AnalyticsConstants.js.map